import React, { useState } from 'react';
import classes from '../main.module.css'
import CountUp from './CountUp';

const AboutUs = () => {
    const [showModal, setShowModal] = useState(false);

    const yearsOfExperience = React.useMemo(() => {
        const startDate = new Date('2024-03-28');
        const today = new Date();
        let years = today.getFullYear() - startDate.getFullYear();
        const m = today.getMonth() - startDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < startDate.getDate())) {
            years--;
        }
        return years;
    }, []);

    const aboutTitle = "Engineering Scalable Digital Experiences.";
    const aboutContent = "Feline is a boutique team crafting high-performance apps and websites. We operate with agility and precision, delivering custom solutions that drive real growth. We don't just build—we innovate to scale your business.";

    return (
        <section id="about" className={classes.AboutSection}>
            <div className={`${classes.Container} ${classes.AboutContainer}`}>

                {/* Images Side */}
                <div className={classes.AboutImageWrapper} data-aos="zoom-in" data-aos-duration="1200">
                    <div className={classes.AboutBackdropPattern}></div>
                    <div className={classes.AboutImageMain}>
                        <img src="/images/about_office.png" alt="Premium office environment" />
                    </div>
                    <div className={classes.AboutImageSecondary}>
                        <img src="/images/about_team.png" alt="Elite team collaboration" />
                    </div>
                    <div className={classes.AboutExperienceBadge}>
                        <div className={classes.BadgeContent}>
                            <span className={classes.BadgeNumber}>{yearsOfExperience}+</span>
                            <span className={classes.BadgeText}>Years<br />Experience</span>
                        </div>
                    </div>
                </div>

                {/* Content Side */}
                <div className={classes.AboutContentWrapper}>
                    <div className={classes.AboutDirection} data-aos="fade-up">
                        <h6>Who We Are</h6>
                        <div className={classes.AboutLine}></div>
                    </div>

                    <h2 className={classes.AboutTitle} data-aos="fade-up" data-aos-delay="100">
                        {aboutTitle.split('Digital Experiences').map((part, index, array) => (
                            <React.Fragment key={index}>
                                {part}
                                {index < array.length - 1 && <span className={classes.HighlightText}>Digital Experiences</span>}
                            </React.Fragment>
                        ))}
                    </h2>

                    <p className={classes.AboutDescription} data-aos="fade-up" data-aos-delay="200">
                        {aboutContent}
                    </p>

                    <div className={classes.AboutStatsGrid}>
                        <div className={classes.AboutStatModern} data-aos="fade-up" data-aos-delay="300">
                            <h3><CountUp end={2} suffix="+" /></h3>
                            <p>Professionals</p>
                        </div>
                        <div className={classes.AboutStatModern} data-aos="fade-up" data-aos-delay="400">
                            <h3><CountUp end={5} suffix="+" /></h3>
                            <p>Projects Done</p>
                        </div>
                        <div className={classes.AboutStatModern} data-aos="fade-up" data-aos-delay="500">
                            <h3><CountUp end={1} suffix="+" /></h3>
                            <p>Global Clients</p>
                        </div>
                    </div>

                    <div className={classes.AboutAction} data-aos="fade-up" data-aos-delay="600">
                        <button className={classes.Button} onClick={() => setShowModal(true)}>
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>

            {/* Contact Modal */}
            {showModal && (
                <div className={classes.ModalOverlay} onClick={() => setShowModal(false)}>
                    <div className={classes.ModalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={classes.ModalClose} onClick={() => setShowModal(false)}>&times;</button>
                        <h3>Get in Touch</h3>
                        <p>Tell us what you need and we'll get back to you shortly.</p>
                        <form className={classes.ModalForm} onSubmit={(e) => { e.preventDefault(); setShowModal(false); alert('Message Sent!'); }}>
                            <input type="text" placeholder="Your Name" required />
                            <input type="email" placeholder="Your Email" required />
                            <textarea placeholder="How can we help you?" rows="4" required></textarea>
                            <button type="submit" className={classes.Button}>Send Message</button>
                        </form>
                    </div>
                </div>
            )}
        </section>
    )

}

export default AboutUs